import { type IssuingProviderEnum } from '../enums/IssuingProvider'

export interface CardholderConstructor {
  id: number
  userId: number
  email: string
  firstName: string
  lastName: string
  profileImage: string
  externalId: string
  tosAccepted: boolean
  secondaryCategoryId: Nullable<number>
  provider: IssuingProviderEnum
}

export class Cardholder {
  id: number
  userId: number
  email: string
  firstName: string
  lastName: string
  profileImage: string
  externalId: string
  tosAccepted: boolean
  secondaryCategoryId: Nullable<number>
  provider: IssuingProviderEnum

  constructor(data: CardholderConstructor) {
    this.id = data.id
    this.userId = data.userId
    this.email = data.email
    this.firstName = data.firstName
    this.lastName = data.lastName
    this.profileImage = data.profileImage
    this.externalId = data.externalId
    this.tosAccepted = data.tosAccepted
    this.secondaryCategoryId = data.secondaryCategoryId
    this.provider = data.provider
  }

  get fullName(): string {
    return `${this.firstName} ${this.lastName}`
  }
}
